if (!console.time) {
    console.time = () => {};
}
if (!console.timeEnd) {
    console.timeEnd = () => {};
}
